import React from 'react';
import { defineMessages } from 'react-intl';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _take from 'lodash/take';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import { intlMessage, opportunityPropType } from 'constants/propTypes';

import Message from 'components/Message';
import { Card, CardSection, CardTitle } from 'components/Card';
import HomeModuleLink from 'features/Home/HomeModuleLink';

import Opportunity from './OpportunityContainer';

const messages = defineMessages({
  highDemandClasses: {
    id: 'opportunities.opportunities-teaser.high-demand-classes',
    defaultMessage: 'High-demand classes this week',
  },
  seeAllRecommendations: {
    id: 'opportunities.opportunities-teaser.see-all-recommendations',
    defaultMessage: 'See all opportunities',
  },
  noRecommendations: {
    id: 'opportunities.opportunities-teaser.no-recommendations',
    defaultMessage:
      'No more recommendations to review, but we’ll notify you by email each day when there are new opportunities to add spots',
  },
});

function OpportunitiesTeaser(props) {
  const {
    hasPermission,
    venueId,
    opportunities,
    opportunitiesStatus,
    title,
    showEmpty = false,
    isLoaded = false,
  } = props;

  if (!hasPermission || !isLoaded) return null;

  if (isLoaded && _isEmpty(opportunities) && !showEmpty) return null;

  const opportunitiesToShow = _take(opportunities, 2);

  return (
    <>
      <Message as="h3" className="mb-l" message={title} />
      <Card>
        <CardSection className="border-b p-l md-p-r" flush>
          <CardTitle>
            <Message message={messages.highDemandClasses} />
          </CardTitle>
        </CardSection>

        <CardSection flush>
          {showEmpty && <Message as="h5" className="text--center p-r" message={messages.noRecommendations} />}
        </CardSection>

        <CardSection className={withMods('opportunities-container', { empty: showEmpty })} flush>
          {opportunitiesToShow.map((opp, idx) => (
            <Opportunity
              key={opp.scheduleId}
              idx={idx}
              opportunity={opp}
              isLoading={_get(opportunitiesStatus, `${opp.scheduleId}.isLoading`, false)}
              isSuccess={_get(opportunitiesStatus, `${opp.scheduleId}.isSuccess`, false)}
              updatedCapacity={_get(opportunitiesStatus, `${opp.scheduleId}.updatedCapacity`)}
            />
          ))}
        </CardSection>
      </Card>
      <HomeModuleLink message={messages.seeAllRecommendations} to={`/classes/${venueId}/opportunities`} />
    </>
  );
}

OpportunitiesTeaser.propTypes = {
  hasPermission: PropTypes.bool.isRequired,
  venueId: PropTypes.number.isRequired,
  isLoaded: PropTypes.bool,
  opportunities: PropTypes.arrayOf(opportunityPropType),
  opportunitiesStatus: PropTypes.shape({}), // TODO: define this shape
  showEmpty: PropTypes.bool,
  title: intlMessage,
};

export default OpportunitiesTeaser;
